module.exports = __webpack_public_path__ + "static/img/school_index_banner_h5.73f08b1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/inviteJob/school_index_banner_h5.png
// module id = auKe
// module chunks = 34